import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useDynamicModule } from '@grandvisionhq/utils';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const { PickupPointsFinder  } = yield import(/* webpackChunkName: 'grandvisionhq-pickup-points' */ '@grandvisionhq/pickup-points');
        return PickupPointsFinder;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupPointsModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/pickup-points', [])
;
const PickupPointsFinderContainer = ({ errorMessage , onPickupPointSelect , itemsToBeShipped  })=>{
    const [PickupPointsFinder, loading, error] = usePickupPointsModule();
    const { featureConfigs  } = useFeatureToggles();
    const { pickupPoints  } = useCheckoutSettings();
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error || !PickupPointsFinder) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            notifyScreenReader: false,
            className: "alert-m-default"
        }, errorMessage);
    }
    return /*#__PURE__*/ React.createElement(PickupPointsFinder, {
        view: "modal",
        onPickupPointSelect: onPickupPointSelect,
        itemsToBeShipped: itemsToBeShipped,
        showCityField: !!(pickupPoints === null || pickupPoints === void 0 ? void 0 : pickupPoints.showCityField),
        mapOptions: {
            mapId: featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.googleDynamicMapsMapId
        }
    });
};

export { PickupPointsFinderContainer };
//# sourceMappingURL=PickupPointsFinderContainer.js.map
